import React, {Component} from 'react'
import PropTypes from 'prop-types'

import Icon from '../icon'

import LegDiagramPreview from '../leg-diagram-preview'
import { distanceString } from '../../../@opentripplanner/core-utils/src/distance'
import { getStepInstructions } from '../../../@opentripplanner/core-utils/src/itinerary'
import { formatDuration } from '../../../@opentripplanner/core-utils/src/time'
import i18n from "../../../../i18nSetup";

/**
 * Default access leg component for narrative itinerary.
 */
export default class AccessLeg extends Component {
  static propTypes = {
    activeStep: PropTypes.number,
    leg: PropTypes.object,
    setActiveLeg: PropTypes.func,
    setActiveStep: PropTypes.func
  }

  _onLegClick = (e) => {
    const {active, leg, index, setActiveLeg} = this.props
    if (active) {
      setActiveLeg(null)
    } else {
      setActiveLeg(index, leg)
    }
  }

  _onStepClick (e, step, index) {
    if (index === this.props.activeStep) {
      this.props.setActiveStep(null)
    } else {
      this.props.setActiveStep(index, step)
    }
  }

  render () {
    const { active, activeStep, index, leg } = this.props
    return (
      <div
        key={index}
        className={`leg${active ? ' active' : ''} access-leg`}>
        <button
          className='header'
          onClick={this._onLegClick}>
          <span><Icon type={`caret-${active ? 'down' : 'right'}`} /></span>
          <span><b>
          {(leg.mode === 'WALK' &&  leg.to.name) ? i18n.t("WALK_TO") + leg.to.name : 
       i18n.t(leg.mode)}
       </b></span>
          <div style={{marginInlineStart:6,marginBlockStart:6,marginBottom:2}}>
          {leg.to.formatted_address ? (<span className='leg-duration'>{leg.to.formatted_address + " • "}</span>) : null}
          <span className='leg-duration'>{formatDuration(leg.duration)}</span>
          {' '}
          <span className='leg-distance'>({distanceString(leg.distance)})</span>
          </div>
        </button>
        {active &&

            <div style={{marginTop:4}}>
              {leg.steps.map((step, stepIndex) => {
                const stepIsActive = activeStep === stepIndex
                return (
                  <button
                    key={stepIndex}
                    className={`step ${stepIsActive ? 'active' : ''}`}
                    onClick={(e) => this._onStepClick(e, step, stepIndex)}>
                    <span className='step-distance'>{getStepInstructions(step) + ' (' + distanceString(step.distance)})</span>
                  </button>
                )
              })}
            </div>
        
        }
        <LegDiagramPreview leg={leg} />
      </div>
    )
  }
}
